import type { ContactStateType, ClientContactType } from '../types';

const typeMap = {
  seller: 'Seller',
  tenant: 'Tenant',
  'landlord/manager': 'Landlord/Manager',
  buyer: 'Buyer',
} as const;

const phoneTypeMap = {
  primary: 'Primary',
  work: 'Work',
  mobile: 'Mobile',
  home: 'Home',
} as const;

export function convertContactToLegacyContact(
  contact: ClientContactType,
  defaultContact: ContactStateType,
): ContactStateType {
  const { id, firstName, lastName, pronoun, email, phones, tags } = contact;

  const contactType = tags.find(tag =>
    ['seller', 'tenant', 'landlord/manager', 'buyer'].includes(tag),
  ) as 'seller' | 'tenant' | 'landlord/manager' | 'buyer';

  const type = typeMap[contactType];

  const updatedContact = {
    ...defaultContact,
    contactId: id,
    type,
    firstName,
    lastName,
    pronoun,
    email,
    ...(type === 'Buyer'
      ? {
          notifications: {
            ...contact.buyerNotifications,
            'Action Required': false,
            'Feedback Collected': false,
          },
          deliveries: { Email: contact.buyerEmailDelivery },
        }
      : {}),
  };

  if (phones.length > 0) {
    updatedContact.phone = phones.map(({ type: phoneType, number }) => ({
        type: phoneTypeMap[phoneType],
        number,
        mustCall: false,
        sendSms: false,
      }));
  }

  return updatedContact;
}
